// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/app/features/recherche-dossiers/recherche-dossiers.component.scss */
.badge-draft {
  background-color: #6c757d; /* Grey */
  color: white;
}

.bg-dpl {
  background-color: #00a95c;
  color: white;
}

.form-label {
  font-weight: bold !important;
}

.badge-soumis {
  background-color: #007bff; /* Blue */
  color: white;
}

.badge-autorise {
  background-color: #28a745; /* Green */
  color: white;
}

.badge-rejete {
  background-color: #dc3545; /* Red */
  color: white;
}

.bade-valide {
  background-color: #28a745; /* Green */
  color: white;
}

.badge-en_cours_evaluation {
  background-color: #ffc107; /* Yellow */
  color: black;
}

.badge-suspendu {
  background-color: #17a2b8; /* Teal */
  color: white;
}

.badge-retire {
  background-color: #343a40; /* Black */
  color: white;
}

.badge-expire {
  background-color: #f8f9fa; /* Light Gray */
  color: black;
}

th {
  color: white !important;
  background-color: #00a95c;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/features/dossier/components/commission-demandes/commission-demandes.component.scss"],"names":[],"mappings":"AAAA,0EAAA;AACA;EACE,yBAAA,EAAA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AACA;EACE,4BAAA;AAEF;;AAAA;EACE,yBAAA,EAAA,SAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,UAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,QAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,UAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,WAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,SAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,UAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,eAAA;EACA,YAAA;AAGF;;AADA;EACE,uBAAA;EACA,yBAAA;AAIF;AACA,4qEAA4qE","sourcesContent":["/* src/app/features/recherche-dossiers/recherche-dossiers.component.scss */\n.badge-draft {\n  background-color: #6c757d; /* Grey */\n  color: white;\n}\n\n.bg-dpl {\n  background-color: #00a95c;\n  color: white;\n}\n.form-label {\n  font-weight: bold !important;\n}\n.badge-soumis {\n  background-color: #007bff; /* Blue */\n  color: white;\n}\n\n.badge-autorise {\n  background-color: #28a745; /* Green */\n  color: white;\n}\n\n.badge-rejete {\n  background-color: #dc3545; /* Red */\n  color: white;\n}\n\n.bade-valide {\n  background-color: #28a745; /* Green */\n  color: white;\n}\n\n.badge-en_cours_evaluation {\n  background-color: #ffc107; /* Yellow */\n  color: black;\n}\n\n.badge-suspendu {\n  background-color: #17a2b8; /* Teal */\n  color: white;\n}\n\n.badge-retire {\n  background-color: #343a40; /* Black */\n  color: white;\n}\n\n.badge-expire {\n  background-color: #f8f9fa; /* Light Gray */\n  color: black;\n}\nth {\n  color: white !important;\n  background-color: #00a95c;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
